export default [
  {
    title: 'breadcrumb.home',
    route: 'home',
    icon: '',
    resource: 'home',
    action: 'read',
  },
];